import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台介绍', href: '#about' },
  { label: '热门话题', href: '#topics' },
  { label: '热度榜单', href: '#ranking' },
  { label: '吃瓜评论', href: '#comments' },
  { label: '图文资讯', href: '#cards' },
  { label: '常见问答', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenu(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px] max-w-[1400px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 shrink-0 cursor-pointer"
          >
            <span className="text-xl md:text-2xl font-bold font-heading text-primary-600">
              17黑料网
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileMenu(!mobileMenu)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-600 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenu ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenu && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1 max-w-[1400px] mx-auto">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}